// extracted by mini-css-extract-plugin
export default {"loader-ring":"Loader_loader-ring__7h1E7"};